import Vue from 'vue';
import moment from 'moment';
import { Geschlecht } from '@/types/Geschlecht';

type TimeFormat = 'HH:mm:ss' | 'HH:mm';

export default class Warteliste {
    /** PK: Identifikation des Patienten | erforderlich */
    public patnr: number | null = null;
    /**  nicht verwendet | max. 10 Zeichen */
    public status: string | null = null;
    /** Zeitpunkt der Aufnahme in die Warteliste */
    public aufnahme: string | null = null;
    /** @deprecated dzt. nicht verwendet */
    public aufruf: string | null = null;
    /** Zeitpunkt RECHNUNG */
    public abrechnung: string | null = null;
    /** Zeitpunkt FERTIG */
    public abschluss: string | null = null;
    /** Anmerkungen bei Aufnahme in Warteliste | max. 50 Zeichen */
    public bemerkungen: string | null = null;
    public folgetermin: string | null = null;

    public patient_nachname: string | null = null;
    public patient_vorname: string | null = null;
    public patient_titel: string | null = null;
    public patient_titel_nach_name: string | null = null;
    public patient_geburtsdatum: string | null = null;
    public patient_geschlecht: Geschlecht | null = null;
    public show: boolean | null = true;

    public waitTime: { hh: number, mm: number, ss: number } = { hh: 0, mm: 0, ss: 0 };

    constructor(data?: Partial<Warteliste>) {
        Object.assign(this, data);
    }

    public get patientName(): string {
        return [this.patient_titel, this.patient_nachname?.toUpperCase(), this.patient_vorname, this.patient_titel_nach_name]
            .filter((str) => str)
            .join(' ');
    }

    public get patientGeburtsdatum(): string {
        return Vue.prototype.$d(this.patient_geburtsdatum) ?? '';
    }

    public get patientGeschlecht(): string {
        switch (this.patient_geschlecht) {
            case Geschlecht.Maennlich:
                return 'männlich';
            case Geschlecht.Weiblich:
                return 'weiblich';
            case Geschlecht.Divers:
                return 'divers';
            case Geschlecht.KeineAngaben:
            default:
                return '';
        }
    }

    public get wartet(): number {
        const { hh, mm, ss } = this.waitTime;
        return (hh * 60 * 60) + (mm * 60) + ss;
    }

    public calcWaitTime(): void {
        const now = moment(this.abschluss ?? undefined);
        const aufnahme = moment(this.aufnahme);
        const duration = moment.duration(now.diff(aufnahme));
        const hh = Math.floor(duration.asHours());
        const mm = duration.minutes();
        const ss = duration.seconds();
        this.waitTime = { hh, mm, ss };
    }

    public wartetFormat(format: TimeFormat): string {
        const time = [this.waitTime.hh, this.waitTime.mm];

        if (format === 'HH:mm:ss') {
            time.push(this.waitTime.ss);
        }

        return time.map((value) => value.toString().padStart(2, '0')).join(':');
    }
}
